/* Precio por pelota en el selector de presentacion (12 / 20 / 30 unidades).

   Dos cosas que hay que respetar:
   1) Shopify entrega los precios en CENTAVOS: 49000 son $490.00.
   2) El emparejado va por el VALOR del input, no por el texto de la etiqueta:
      Dawn mete dentro del label un span oculto ("Variante no disponible"). */
(function () {
  var nativeFetch = window.fetch.bind(window);
  var fmt = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 });
  var MAP = null;

  function routeRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function units(title) {
    var m = (title || '').match(/(\d+)\s*(unidad|pieza|pelota|pza)/i);
    return m ? parseInt(m[1], 10) : 0;
  }

  function norm(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  /* Devuelve pesos, no centavos. */
  function build(product) {
    var map = {};
    (product.variants || []).forEach(function (v) {
      var n = units(v.title);
      if (!n) return;
      var per = (v.price / 100) / n;
      map[norm(v.title)] = per;
      (v.options || []).forEach(function (o) {
        if (units(o)) map[norm(o)] = per;
      });
    });
    return map;
  }

  function apply() {
    if (!MAP || !Object.keys(MAP).length) return;

    document.querySelectorAll('.product-form__input input[type="radio"]').forEach(function (input) {
      var per = MAP[norm(input.value)];
      if (per == null) return;
      var lab = input.id ? document.querySelector('label[for="' + input.id + '"]') : input.nextElementSibling;
      if (!lab || lab.querySelector('.mb-unit')) return;
      var s = document.createElement('small');
      s.className = 'mb-unit';
      s.textContent = fmt.format(per) + ' c/u';
      lab.appendChild(s);
    });

    document.querySelectorAll('.product-form__input select option').forEach(function (op) {
      if (op.dataset.mbUnit === '1') return;
      var per = MAP[norm(op.value)];
      if (per == null) return;
      op.dataset.mbUnit = '1';
      op.textContent = op.textContent.trim() + ' — ' + fmt.format(per) + ' c/u';
    });
  }

  function handle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function init() {
    if (MAP) { apply(); return; }
    var h = handle();
    if (!h) return;
    nativeFetch(routeRoot() + 'products/' + h + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        MAP = build(p);
        apply();
        if (window.MutationObserver) {
          var scope = document.querySelector('.product__info-container');
          if (scope) {
            var t = null;
            new MutationObserver(function () {
              clearTimeout(t);
              t = setTimeout(apply, 140);
            }).observe(scope, { childList: true, subtree: true });
          }
        }
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
  setTimeout(init, 700);
  setTimeout(init, 1800);
})();
